import React from "react";
import Heading from "../../heading/heading";
import Values from "../coreValuesSection/values";
import SideContent from "../../landingPage/side_content";
import side_dots from "./images/side_dots.png";
import top_dots from "./images/top_dots.png";
import dots from "./images/dots.png";
import sideImage from "./images/side.png";
import image from "./images/side_image.png";
import aim from "./images/aim.png";
import "./mission.css";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import list from "../coreValuesSection/list";

function Mission() {
  return (
    <div>
      <Heading title="Our Imperative Mission" />

      <SideContent
        btn=""
        side_image={sideImage}
        side={side_dots}
        top={top_dots}
        title="Vision"
        para="Adopting abandoned children, Orphans and Vulnerable children, 
        and the youths. Raise them into responsible and productive communities 
        with a capacity to coexist in society."
      />

      <div className="container-side">
        <div className="side-content-side">
          <h1 className="about-header">Mission</h1>
          <p className="about-para">
            1. Home for the homeless 2. Family for the orphaned and abandoned
            Children. 3. Place for the foundation and growth of Christian life.
            4. Institution that unlocks the mind for a productive community. 5.
            Place where youths discover their happiness and joy to the
            fulfillment of their lives 6. Place where life skill is discovered
            and developed
          </p>
        </div>
        <div className="side-image-side">
          <img src={image} alt="" />
          <img className="side_dots" src={dots} alt="" />
        </div>
      </div>

      <SideContent
        btn=""
        side_image={aim}
        side={side_dots}
        top={top_dots}
        title="Aim"
        para="1. A non-governmental organization aiming at lifting up the living standards of the
            children and the youths with a positive and healthy mind.
            2. We aim at propagating good morals among the youths and the children.
            3. Aiming at providing training and child development programs."
      />

      <Heading title="Our Core Values" />

      <div className="bg-mission">
        <Carousel arrows>
          {list.map((slide) => (
            <Values key={slide.id} title={slide.title} img={slide.image} para={slide.para} />
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Mission;
